export const isLectureLive = (lecture) => {
  return isLectureBegun(lecture) && new Date(lecture.endTime) >= new Date();
};

export const isLectureAvailable = (lecture) => {
  return lecture && (lecture.type === "flipped" || isLectureBegun(lecture));
};

export const isLectureBegun = (lecture) => {
  return lecture && lecture.type === "live" && new Date(lecture.startTime) <= new Date();
};

export const isWaitingForTeacher = (lecture, teacher) => {
  return lecture && isLectureLive(lecture) && !teacher;
};

export const formatSeconds = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  let secs = Math.floor(seconds % 60);
  if (secs < 10) secs = "0" + secs;
  return `${minutes}:${secs}`;
};
